export default __webpack_public_path__ + "static/1_37-445f55563f0e6909ce48b3ceab9d4da7.png";